function UcinnostProcesnychZariadeni(){
    return(
        <div>
            UcinnostProcesnychZariadeni
        </div>
    );
};

export default UcinnostProcesnychZariadeni;